module.exports = __webpack_public_path__ + "img/ibg.116913ba.png";